import { render, staticRenderFns } from "./LogementTab.vue?vue&type=template&id=2d469a72&"
import script from "./LogementTab.vue?vue&type=script&lang=js&"
export * from "./LogementTab.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports